import { withTranslation } from 'react-i18next';
import React from "react";
import TableItem from "../../views/administration/manage-users/TableItem";
import { PrintHeader } from "./parts/PrintHeader";

class PrintUserListComponent extends React.Component {
    constructor(props) {
        super(props);

        this.data = {
            organisation: this.props.store.User.data.organisation,
        };
    }


    render() {
        return (
            <div className="print">
                <PrintHeader
                    data={this.data}
                    title={this.props.t('print.volunteerList')}
                    selectedCategories={[]}
                />
                <table className="table-users">
                    <thead>
                        <tr>
                            <th>{this.props.t('common.name')}</th>
                            <th>{this.props.t('common.email')}</th>
                            <th>{this.props.t('common.role')}</th>
                            <th>{this.props.t('common.group')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.props.users.map((user) =>
                            <TableItem
                                key={user.id}
                                user={user}
                                store={this.props.store}
                                columns={['name', 'email', 'userlevel', 'group']}
                            />
                        )}
                    </tbody>
                </table>
            </div>
        );
    }
}

// The parent holds a ref to this component and calls its methods, so the translation HOC must
// forward the ref — without `withRef` it returns a function component and the ref stays null.
export const PrintUserList = withTranslation(undefined, { withRef: true })(PrintUserListComponent);
